import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import PoetCard from './PoetCard.js';

function PoetList(props){

  const payload = props.poets.map((poet) => {
    return (
      <PoetCard
        key={poet.poetID}
        poet={poet}
      />
    )
  });
  return (
    <div id="PoetList">
      <h1>{props.heading}</h1>
      <div className="poet-list-flex">
        {payload}
      </div>
    </div>
  )
}

export default PoetList;



// WEBPACK FOOTER //
// ./src/components/Home/PoetList.js